import { SplashScreenPhone } from '@zonofi/gandalf-components';
import React from 'react';
import './signup-splash-screen.scss';
import { useLocation } from 'react-router-dom';
import { SellerDetails } from '@zonofi/zo-types';
interface SignupSplashScreenProps {
  onUpdateValue?: (key: string, value: string | boolean) => void;
  setSellerDetails?: React.Dispatch<React.SetStateAction<SellerDetails>>;
}
export const SignupSplashScreen: React.FC<SignupSplashScreenProps> = ({
  onUpdateValue,
  setSellerDetails,
}) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const utmSource = searchParams.get('utm_source');
  const utmMedium = searchParams.get('utm_medium');
  const utmCampaign = searchParams.get('utm_campaign');
  const utmTerm = searchParams.get('utm_term');
  const utmId = searchParams.get('utm_id');
  const utmContent = searchParams.get('utm_content');
  const fcId = searchParams.get('fbclid');
  const gcId = searchParams.get('gclid');
  const utmCampaignIdRes = searchParams.get('campaignid');
  const adId = searchParams.get('ad_id');

  React.useEffect(() => {
    const fullUrl = window.location.href;
    setSellerDetails((prev) => {
      return {
        ...prev,
        utmSource: utmSource || '',
        utmMedium: utmMedium || '',
        utmCampaign: utmCampaign || '',
        utmCampaignId: utmCampaignIdRes || '',
        x_fclid: fcId || '',
        x_gclid: gcId || '',
        utmTerm: utmTerm || '',
        utmId: utmId || '',
        x_ad_id: adId || '',
        utmContent: utmContent || '',
        referenceLink: fullUrl || '',
      };
    });
  }, []);

  return (
    <div className="signup-splash-screen">
      <SplashScreenPhone onUpdateValue={onUpdateValue} />
    </div>
  );
};
